import { jsx as _jsx } from "react/jsx-runtime";
import Legal from '~components/legal';
const TermsOfService = () => _jsx(Legal, { id: "terms-of-service" });
export default TermsOfService;
